/**
 * @public
 */
export var Thunk;
(function (Thunk) {
    function of(value) {
        return () => value;
    }
    Thunk.of = of;
    function map(thunk, mapper) {
        return () => mapper(thunk());
    }
    Thunk.map = map;
    function flatMap(thunk, mapper) {
        return () => mapper(thunk())();
    }
    Thunk.flatMap = flatMap;
    function reduce(thunk, reducer, accumulator) {
        return reducer(accumulator, thunk());
    }
    Thunk.reduce = reduce;
})(Thunk || (Thunk = {}));
//# sourceMappingURL=thunk.js.map